import { useEffect, useMemo, useState } from 'react';

import { Grid } from '@mui/material';
import NavigationTabs, { TabProps } from '@apigrowfinance/pbolt-navigation-tabs';
import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAccount } from '@contexts/AccountProvider';

const TabStrip = () => {
    const { formatMessage } = useIntl();
    const [selectedTab, setSelectedTab] = useState('account');
    const { account, isLoading } = useAccount();
    const navigate = useNavigate();
    const location = useLocation();

    const tabs: TabProps[] = useMemo(() => {
        return [
            {
                label: formatMessage({
                    id: `AccountDetailTabs.accountDetails`,
                    defaultMessage: 'Account details',
                }),
                type: 'account',
            },
            {
                label: formatMessage({
                    id: `AccountDetailTabs.users`,
                    defaultMessage: 'Customers',
                }),
                type: 'customers',
            },
            ...(account?.program_type !== 'LENDING'
                ? [
                      {
                          label: formatMessage({
                              id: `AccountDetailTabs.controls`,
                              defaultMessage: 'Controls',
                          }),
                          type: 'controls',
                      },
                  ]
                : []),
            {
                label: formatMessage({
                    id: `AccountDetailTabs.phoneNumbers`,
                    defaultMessage: 'Phone numbers',
                }),
                type: 'phonenumbers',
            },
            {
                label: formatMessage({
                    id: `AccountDetailTabs.addresses`,
                    defaultMessage: 'Addresses',
                }),
                type: 'addresses',
            },
        ];
    }, [formatMessage, account?.program_type]);

    useEffect(() => {
        tabs.map((tab) => {
            const matchPath = location.pathname.includes(tab.type);
            if (matchPath) {
                setSelectedTab(tab.type);
            }
        });
    }, [location.pathname, tabs]);

    const getRoute = (tab: string) => {
        switch (tab) {
            case 'customers':
                return `/${account.account_id}/detail/customers`;
            case 'controls':
                return `/${account.account_id}/detail/controls`;
            case 'account':
                return `/${account.account_id}/detail`;
            case 'phonenumbers':
                return `/${account.account_id}/detail/phonenumbers`;
            case 'addresses':
                return `/${account.account_id}/detail/addresses`;

            default:
                return tab;
        }
    };

    const handleChange = (to: string) =>
        navigate(getRoute(to), { replace: true });

    return (
        <Grid item>
            <NavigationTabs
                isLoading={isLoading}
                tabs={tabs}
                onChange={handleChange}
                selectedTab={selectedTab}
            />
        </Grid>
    );
};

export default TabStrip;
